import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { hearts, loadHearts, toggleHeart } from "../lib/hearts";

const HEART = "M12 21s-7.5-4.6-9.6-9.2C.9 8.5 3 5 6.4 5c2.1 0 3.6 1.2 4.6 2.8C12 6.2 13.5 5 15.6 5 19 5 21.1 8.5 19.6 11.8 17.5 16.4 12 21 12 21z";

// Hearts bloom upward in the painting's own colours (heart shapes, never round dots).
export function bloomHearts(x, y, colours = []) {
  const cols = colours.length ? colours : ["#E06B8B", "#F0A93A", "#C06AB0"];
  for (let i = 0; i < 9; i++) {
    const el = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    el.setAttribute("viewBox", "0 0 24 24");
    el.setAttribute("data-testid", "heart-bloom");
    const s = 18 + Math.random() * 18;
    el.style.cssText = `position:fixed;left:${x - s / 2}px;top:${y - s / 2}px;width:${s}px;height:${s}px;z-index:95;pointer-events:none;--dx:${(Math.random() - 0.5) * 160}px;--dy:${-70 - Math.random() * 130}px;--r:${(Math.random() - 0.5) * 50}deg;animation:heart-bloom ${1.3 + Math.random() * 0.7}s ease-out ${i * 0.05}s forwards;opacity:0`;
    el.innerHTML = `<path d="${HEART}" fill="${cols[i % cols.length]}" fill-opacity="0.85"/>`;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 2600);
  }
}

export async function heartFrom(painting, x, y) {
  const on = await toggleHeart(painting.id).catch(() => null);
  if (on) bloomHearts(x, y, painting.palette);
  return on;
}

export function HeartToggle({ painting, testid, className = "" }) {
  const [on, setOn] = useState(hearts.mine.has(painting.id));
  useEffect(() => {
    const sync = () => setOn(hearts.mine.has(painting.id));
    if (!hearts.loaded) loadHearts().then(sync).catch(() => {});
    window.addEventListener("afae-hearts", sync);
    return () => window.removeEventListener("afae-hearts", sync);
  }, [painting.id]);
  const click = async (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const v = await heartFrom(painting, r.left + r.width / 2, r.top + r.height / 2);
    if (v !== null) setOn(v);
  };
  return (
    <button data-testid={testid} data-on={on ? "1" : "0"} aria-pressed={on} aria-label={on ? "Take back your heart" : "Leave a heart"} onClick={click} className={`flex h-11 w-11 items-center justify-center rounded-full border border-white/80 bg-[#FBF7F2]/95 text-[#B0487A] shadow-md backdrop-blur-xl transition-transform duration-200 hover:scale-105 active:scale-95 ${className}`}>
      <Heart size={20} fill={on ? "#D9577F" : "none"} strokeWidth={1.8} />
    </button>
  );
}
